import { useState, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

export function useSavePersonalEvent() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((personalEvent) => {
    setSaving(true);
    const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
    const request = personalEvent.id
      ? quarkusApi.put('/personal-events', personalEvent, authHeader)
      : quarkusApi.post('/personal-events', personalEvent, authHeader);
    return request.finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
